export enum AdvancedFeaturesEvents {
    TRANSLATIONS_LOADED = 'advancedFeatures/translationsLoaded',
}

const dispatchTranslationsLoaded = function () {
    const event = new Event(AdvancedFeaturesEvents.TRANSLATIONS_LOADED);
    window.dispatchEvent(event);
};

export default {
    dispatchTranslationsLoaded,
};
